module.exports = __webpack_public_path__ + "img/avatar2.becaaa39.png";